import { StarIcon } from '@heroicons/react/24/solid';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';
import { BikeIcon, TagIcon } from 'utils/svg';
import ImageLoader from 'components/ImageLoader/';
import { useSelector } from 'react-redux';
import TableNumber from 'ufood-x/components/Outlet/TableNumber';
import { useParams } from 'react-router-dom';

const Detail = () => {
	const { type } = useParams();
	const { details: outlet } = useSelector((store) => store.outlet);
	const isClosed = outlet?.storeOpen === '0';
	const user = useSelector((store) => store?.user);
	const { tableNumber } = useSelector((store) => store?.order);

	return (
		<div>
			<div className='h-full max-h-52'>
				<div className='aspect-[2/1] w-full h-full'>
					<ImageLoader alt={outlet?.storeSlug} src={outlet?.bannerImage} className='h-full w-full object-cover' />
				</div>
			</div>
			<div className={`p-4 w-full max-w-lg ${isClosed ? 'pointer-events-none' : ''}`}>
				<div className='relative rounded-lg shadow-xl bg-white flex flex-col'>
					{isClosed && outlet?.outletOpenTime && (
						<div className='flex items-center gap-2 px-4 py-3 rounded-t-lg' style={{ backgroundColor: '#FDEFDC' }}>
							<BuildingStorefrontIcon className='w-5 h-5 text-gray-500 shrink-0' />
							<p className='text-xs text-gray-500'>
								<span className='font-bold text-gray-700'>Maaf, toko ini sedang tutup. </span>
								Pesan untuk pukul {outlet?.outletOpenTime}
							</p>
						</div>
					)}
					<div className='relative p-4 flex'>
						{isClosed && <div className='absolute inset-0 bg-white/60 z-[1] rounded-lg' />}
						<ImageLoader alt={outlet?.storeSlug} src={outlet?.storeImage} className='h-12 w-12 rounded-lg resize-none' />
						<div className='grow pl-2'>
							<div className='text-gray-900 text-sm font-semibold'>{outlet?.storeName}</div>
							<div className='flex gap-1 items-center pt-1'>
								<StarIcon className='h-4 w-4 text-star' />
								<div className='text-black text-xs'>{outlet?.rating || outlet?.Rating || 0}</div>
								<div className='text-gray-900 text-xs'>({outlet?.totalRating || 0})</div>
							</div>
							<div className='flex flex-row gap-1 pt-1'>
								<BikeIcon />
								<div className='flex flex-row'>
									<div className='text-gray-900 text-xs'>{Math.floor(Number(outlet?.distance || 0) * 10) / 10} km</div>
									<div className='hidden text-xs'>
										<div className='px-1'>-</div>
										<div className='flex flex-row'>
											Delivery <p className='px-1 line-through'>Rp16.000</p> Rp6.000
										</div>
									</div>
								</div>
							</div>
							<div className={`${!outlet?.offerInfo && 'hidden'} gap-1 pt-1 flex items-center`}>
								<TagIcon className={`fill-[var(--rose-violet)] h-4.5 w-4.5`} />
								<div className='font-semibold text-xs text-gray-900'>{outlet?.offerInfo}</div>
							</div>
							{(type === 'dinein' && tableNumber?.table_number && user?.is_b2b) && (
								<>
								<div className='border-t-1 mt-4 border-solid border-gray-200 mx-4' />
								<TableNumber tableNumber={tableNumber?.table_number} />
								</>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Detail;
